<template>
  <div :class="{ fullSize: loading }">
    <v-row
        class="mx-0"
        align-center
        justify-center
        :class="{ fullSize: loading }"
    >
      <v-col cols="12" class="pa-0 generalClass-table-padding" :key="pageKey">
        <loading-page v-if="loading"></loading-page>
        <default-page
            v-else-if="appInstancesError.error || !getApplicationInstances.length"
            imageUrl="/img/dynamic-src-images/applications.svg"
            title="Applications"
            :text="pageText"
            :errorMessage="
            appInstancesError.error ? appInstancesError.details.message : ''
          "
            :buttonText="appInstancesError.error ? 'Reload' : 'Get Started'"
            @button-clicked="buttonClicked"
        ></default-page>
        <div v-else>
          <v-row no-gutters>
            <v-col cols="12">
              <v-data-table
                  :mobile-breakpoint="0"
                  :height="`${
                  $vuetify.breakpoint.mdAndUp
                    ? windowSizeY - 100
                    : windowSizeY - 96
                }px`"
                  :items-per-page="itemsPerPage"
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  fixed-header
                  :custom-sort="currentSortingAlgo"
                  :headers="headers"
                  :items="getApplicationInstancesAndIndexes"
                  :class="{ 'empty-data-table': !getApplicationInstances.length }"
                  :expanded.sync="expanded"
                  dense
                  hide-default-header
                  hide-default-footer
                  sort-by="version"
                  class="main_page_table"
                  item-key="id"
                  single-expand
              >
                <template v-slot:header="{ props: { headers } }">
                  <thead>
                  <tr>
                    <th
                        v-for="(header, index) in headersCounter"
                        :key="index"
                        class="allTableHeaders"
                        :style="
                          headers[index].value === 'action' && addButtonOverLaps
                            ? 'width: 248px;'
                            : 'opacity:1;'
                        "
                    >
                      <v-row align="center" justify="center">
                        <v-col height="100%">
                          <v-row
                              :class="
                                headers[index].value === 'action'
                                  ? 'pl-0'
                                  : 'pl-3'
                              "
                              :style="
                                headers[index].value === 'action' ||
                                headersCounter === 1
                                  ? 'justify-content: center;'
                                  : ''
                              "
                          >
                            <v-hover v-slot:default="{ hover }">
                              <p
                                  :class="
                                    headers[index].value === 'action'
                                      ? 'text-center'
                                      : 'allTableHeadersHover'
                                  "
                                  class="my-0 fullHeight"
                                  @click="
                                    currentSortingAlgo = getNewSortingAlgo(
                                      headers[index]
                                    );
                                    selectedHeader = headers[index].value;
                                  "
                              >
                                {{ headers[index].text }}
                                <v-icon
                                    v-show="headers[index].value !== 'action'"
                                    :style="
                                      hover ||
                                      selectedHeader === headers[index].value
                                        ? 'transition: opacity 0.1s;opacity: 1; cursor: pointer;color: white !important;'
                                        : 'opacity: 0.2;'
                                    "
                                    style="font-size: 12px; margin-left: -3px"
                                >
                                  {{
                                    getSortingIcon(
                                        headers[index].currentSortAlg
                                    )
                                  }}
                                </v-icon>
                              </p>
                            </v-hover>
                          </v-row>
                        </v-col>
                      </v-row>
                    </th>
                  </tr>
                  </thead>
                </template>

                <template v-slot:item="{ item, index }">
                  <tr
                      :id="
                      $vuetify.theme.dark
                        ? 'dataTableRow_dark'
                        : 'dataTableRow_light'
                    "
                      @click="
                      headersCounter !== headers.length ? expandRow(item) : ''
                    "
                      class="rowClick"
                  >
                    <td
                        v-for="(head, index) in headersCounter === headers.length
                        ? headersCounter - 1
                        : headersCounter"
                        :key="index"
                        :class="
                        $vuetify.breakpoint.mdAndUp
                          ? 'table_Row pl-3'
                          : 'table_Row pl-2'
                      "
                    >
                      <v-row v-if="headersCounter === 1" justify="center">
                        <!-- <v-col v-if="headersCounter == 1" cols="3"></v-col> -->
                        <v-col
                            :cols="headersCounter === 1 ? 8 : 12"
                            class="pa-0"
                            :class="
                            getCellClass(
                              item[headers[index].value],
                              headers[index].value
                            )
                          "
                        >
                          <v-icon
                              v-if="
                              headers[index].value === 'name' &&
                              headersCounter !== headers.length
                            "
                              :class="
                              expanded.some((el) => el.id === item.id)
                                ? 'red--text pr-2'
                                : 'primary--text pr-2'
                            "
                              style="
                              font-size: 16px;
                              margin-bottom: 4px !important;
                            "
                          >
                            {{
                              expanded.some((el) => el.id === item.id)
                                  ? "fas fa-times-circle"
                                  : "fas fa-chevron-circle-down"
                            }}
                          </v-icon>
                          <p
                              class="d-inline"
                              :class="`${getCellClass(
                              item[headers[index + 1].value],
                              'appStatus'
                            )} pa-0`"
                          >
                            {{ item[headers[index].value] }}
                          </p>
                        </v-col>
                      </v-row>

                      <v-tooltip
                          v-else-if="headers[index].value === 'name'"
                          :disabled="!isAdmin || isNotDesktop"
                          bottom
                          nudge-left="100"
                      >
                        <template v-slot:activator="{ on }">
                          <div
                              v-on="on"
                              :class="
                              getCellClass(
                                item[headers[index].value],
                                headers[index].value
                              )
                            "
                              class="ml-3"
                              :style="
                              $vuetify.breakpoint.width > 900
                                ? 'margin-right:-100px;'
                                : ''
                            "
                          >
                            <v-icon
                                v-if="
                                headers[index].value === 'name' &&
                                headersCounter !== headers.length
                              "
                                :class="
                                expanded.some((el) => el.id === item.id)
                                  ? 'red--text pr-1'
                                  : 'primary--text pr-1'
                              "
                                style="font-size: 16px"
                            >
                              {{
                                expanded.some((el) => el.id === item.id)
                                    ? "fas fa-times-circle"
                                    : "fas fa-chevron-circle-down"
                              }}
                            </v-icon>
                            {{ item[headers[index].value] }}
                          </div>
                        </template>
                        <span>
                          <div v-if="item.id">ID: {{ item.id }}</div>
                          <div v-if="item.lastMessage" style="max-width: 250px">
                            Last Message: {{ item.lastMessage }}
                          </div>
                        </span>
                      </v-tooltip>
                      <div
                          v-else
                          :class="
                          getCellClass(
                            item[headers[index].value],
                            headers[index].value
                          )
                        "
                          class="ml-3"
                          :style="
                          $vuetify.breakpoint.width > 900
                            ? 'margin-right:-100px;'
                            : ''
                        "
                      >
                        <v-icon
                            v-if="
                            headers[index].value === 'name' &&
                            headersCounter !== headers.length
                          "
                            :class="
                            expanded.some((el) => el.id === item.id)
                              ? 'red--text pr-1'
                              : 'primary--text pr-1'
                          "
                            style="font-size: 16px"
                        >
                          {{
                            expanded.some((el) => el.id === item.id)
                                ? "fas fa-times-circle"
                                : "fas fa-chevron-circle-down"
                          }}
                        </v-icon>
                        {{ item[headers[index].value] }}
                        <!-- {{
                          headers[index].value == "name"
                            ? `(${item.identity.substring(0, 2)})`
                            : ""
                        }} -->
                      </div>
                    </td>
                    <td
                        v-if="headersCounter === headers.length"
                        class="text-center"
                    >
                      <v-btn
                          :id="`run-instance${index}`"
                          :disabled="!checkStatus().isRunAllowed(item.appStatus)"
                          :loading="
                          playButtonLoading &&
                          checkStatus().isRunAllowed(item.appStatus) &&
                          loadingIds.some((lid) => lid === item.id)
                        "
                          icon
                      >
                        <span
                            @click="
                            playButtonLoading = true;
                            loadingIds.push(item.id);
                            handleAction(
                              item.id,
                              item.appStatus === 'SUSPENDED'
                                ? ACTIONS.RESUME
                                : ACTIONS.START
                            );
                          "
                            style="font-size: 28px"
                            class="icon-play-21x21"
                        >
                          <span
                              :class="
                              !checkStatus().isRunAllowed(item.appStatus)
                                ? 'path1Disabled letterSpacing0'
                                : 'path1 letterSpacing0'
                            "
                          ></span>
                          <span class="path2"></span>
                        </span>
                      </v-btn>

                      <v-tooltip :disabled="!checkStatus().isRunAllowed(item.appStatus)"
                                 :activator="`#run-instance${index}`" bottom>
                        <span>Run</span>
                      </v-tooltip>

                      <!-- <v-btn
                        v-if="isAdmin"
                        :id="`pause-instance${index}`"
                        icon
                        :disabled="
                          checkStatus().isRunAllowed(item.appStatus) ||
                          item.appStatus === 'TERMINATED'
                        "
                      >
                        <span
                          @click="
                            playButtonLoading = false;
                            handleAction(item.id, ACTIONS.SUSPEND);
                          "
                          style="font-size: 28px"
                          class="icon-pause-21x21"
                        >
                          <span
                            :class="
                              checkStatus().isRunAllowed(item.appStatus) ||
                              item.appStatus === 'TERMINATED'
                                ? 'path1Disabled letterSpacing0'
                                : 'path1 letterSpacing0'
                            "
                          ></span>

                          <span class="path3 letterSpacing0"></span>
                          <span class="path2"></span>
                        </span>
                      </v-btn>
                      <v-tooltip :activator="`#pause-instance${index}`" bottom>
                        <span>Suspend</span>
                      </v-tooltip> -->

                      <v-btn
                          :id="`terminate-instance${index}`"
                          icon
                          :disabled="item.appStatus === 'TERMINATED'"
                          :loading="
                          terminateButtonLoading &&
                          checkStatus().isTerminateAllowed(item.appStatus) &&
                          loadingIds.some((lid) => lid === item.id)
                        "
                      >
                        <span
                            @click="
                            terminateButtonLoading = true;
                            loadingIds.push(item.id);
                            terminateApplication(item.id);
                          "
                            style="font-size: 28px"
                            class="icon-stop-21x21"
                        >
                          <span
                              :class="
                              item.appStatus === 'TERMINATED'
                                ? 'path1Disabled letterSpacing0'
                                : 'path1 letterSpacing0'
                            "
                              class="path1"
                          ></span>
                          <span class="path2"></span>
                        </span>
                      </v-btn>
                      <v-tooltip
                          :activator="`#terminate-instance${index}`"
                          bottom
                      >
                        <span>Terminate</span>
                      </v-tooltip>

                      <v-btn
                          v-if="isAdmin"
                          :id="`moremenu-instance${index}`"
                          @click="
                          pinging = PING_STATUS.DEFAULT;
                          actionsMenuCurrentID = item.id;
                        "
                          icon
                      >
                        <span
                            style="font-size: 28px; margin-right: 2px"
                            class="icon-more-21x21 letterSpacing0"
                        >
                          <span class="path1 letterSpacing0"></span>
                          <span class="path2 letterSpacing0"></span>
                          <span class="path3 letterSpacing0"></span>
                          <span class="path4 letterSpacing0"></span>
                        </span>
                      </v-btn>
                      <v-tooltip v-else bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                              @click="handleAction(item.id, 'configure', item.name)"
                              v-on="on"
                              rounded
                              class="primary ml-1"
                              icon
                              text
                              dark
                              width="28"
                              height="28"
                          >
                            <v-icon style="font-size: 14px">fas fa-cogs</v-icon>
                            <!-- <v-icon style="font-size: 15px">fas fa-cog</v-icon> -->
                            <!-- <v-icon small>icon-configurations-19x19</v-icon> -->
                          </v-btn>
                        </template>
                        <span>Configurations</span>
                      </v-tooltip>
                      <v-menu
                          :close-on-content-click="true"
                          :v-model="
                          actionsPanel && item.id === actionsMenuCurrentID
                        "
                          style="margin-top: 12px"
                          bottom
                          right
                          :activator="`#moremenu-instance${index}`"
                      >
                        <v-list dense>
                          <template v-for="listItem in items">
                            <!-- v-if="showInstanceAction(listItem)" -->
                            <v-list-item
                                :key="listItem.title"
                                @click="
                                handleAction(
                                  item.id,
                                  listItem.action,
                                  item.name
                                )
                              "
                            >
                              <v-list-item-action class="mr-3">
                                <v-icon small>{{ listItem.icon }}</v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                    listItem.title
                                  }}
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action
                                  v-if="listItem.title === 'ping'"
                                  class="mr-3"
                              >
                                <v-progress-circular
                                    v-if="pinging === PING_STATUS.ACTIVE"
                                    indeterminate
                                    color="primary"
                                    width="3"
                                    size="18"
                                ></v-progress-circular>
                                <v-icon
                                    v-else-if="pinging === PING_STATUS.DONE"
                                    small
                                    color="primary"
                                >fas fa-check
                                </v-icon
                                >
                                <v-icon
                                    v-else-if="pinging === PING_STATUS.REJECTED"
                                    small
                                    color="red"
                                >fas fa-exclamation-circle
                                </v-icon
                                >
                              </v-list-item-action>
                            </v-list-item>
                          </template>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-item="{ item }">
                  <tr
                      v-for="(head, index) in headers.length - headersCounter"
                      :key="index"
                      class="expandBackground"
                  >
                    <v-row
                        style="height: 32px"
                        class="expandRowClass_Border mx-0"
                        justify="space-around"
                    >
                      <v-col
                          v-if="$vuetify.breakpoint.width < 411"
                          cols="1"
                      ></v-col>
                      <v-col class="py-0 pl-2pr-0" cols="3">
                        <p
                            class="ml-1 my-1"
                            style="font-weight: 600; font-size: 14px"
                        >
                          {{ headers[headersCounter + index].text }}
                        </p>
                      </v-col>
                      <v-col cols="8" class="py-0 pl-4 pr-1">
                        <p
                            v-if="
                            headers[headersCounter + index].value !== 'action'
                          "
                            class="ml-1 my-1 text-center"
                            :class="
                            getCellClass(
                              item[headers[headersCounter + index].value],
                              headers[headersCounter + index].value
                            )
                          "
                            style="font-size: 14px"
                        >
                          {{ item[headers[headersCounter + index].value] }}
                          {{
                            headers[headersCounter + index].value === "name"
                                ? `(${item.identity.substring(0, 2)})`
                                : headers[headersCounter + index].value ===
                                "action"
                                    ? ""
                                    : ""
                          }}
                        </p>
                        <div v-else class="text-center">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                  height="32"
                                  width="32"
                                  v-on="isNotDesktop ? 0 : on"
                                  :disabled="
                                  !checkStatus().isRunAllowed(item.appStatus)
                                "
                                  :loading="
                                  playButtonLoading &&
                                  checkStatus().isRunAllowed(item.appStatus) &&
                                  loadingIds.some((lid) => lid === item.id)
                                "
                                  icon
                              >
                                <span
                                    @click="
                                    playButtonLoading = true;
                                    loadingIds.push(item.id);
                                    handleAction(
                                      item.id,
                                      item.appStatus === 'SUSPENDED'
                                        ? ACTIONS.RESUME
                                        : ACTIONS.START
                                    );
                                  "
                                    style="font-size: 28px"
                                    class="icon-play-21x21"
                                >
                                  <span
                                      :class="
                                      !checkStatus().isRunAllowed(
                                        item.appStatus
                                      )
                                        ? 'path1Disabled letterSpacing0'
                                        : 'path1 letterSpacing0'
                                    "
                                  ></span>
                                  <span class="path2"></span>
                                </span>
                              </v-btn>
                            </template>
                            <span>Run</span>
                          </v-tooltip>
                          <v-tooltip bottom v-if="isAdmin">
                            <template v-slot:activator="{ on }">
                              <v-btn
                                  height="32"
                                  width="32"
                                  icon
                                  :disabled="
                                  checkStatus().isRunAllowed(item.appStatus) ||
                                  item.appStatus === 'TERMINATED'
                                "
                              >
                                <span
                                    @click="
                                    playButtonLoading = false;
                                    handleAction(item.id, ACTIONS.SUSPEND);
                                  "
                                    v-on="isNotDesktop ? 0 : on"
                                    style="font-size: 28px"
                                    class="icon-pause-21x21"
                                >
                                  <span
                                      :class="
                                      checkStatus().isRunAllowed(
                                        item.appStatus
                                      ) || item.appStatus === 'TERMINATED'
                                        ? 'path1Disabled letterSpacing0'
                                        : 'path1 letterSpacing0'
                                    "
                                  ></span>

                                  <span class="path3 letterSpacing0"></span>
                                  <span class="path2"></span>
                                </span>
                              </v-btn>
                            </template>
                            <span>Suspend</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                  height="32"
                                  width="32"
                                  icon
                                  :disabled="item.appStatus === 'TERMINATED'"
                                  :loading="
                                  terminateButtonLoading &&
                                  checkStatus().isTerminateAllowed(
                                    item.appStatus
                                  ) &&
                                  loadingIds.some((lid) => lid === item.id)
                                "
                              >
                                <span
                                    v-on="isNotDesktop ? 0 : on"
                                    @click="terminateApplication(item.id)"
                                    style="font-size: 28px"
                                    class="icon-stop-21x21"
                                >
                                  <span
                                      :class="
                                      item.appStatus === 'TERMINATED'
                                        ? 'path1Disabled letterSpacing0'
                                        : 'path1 letterSpacing0'
                                    "
                                      class="path1"
                                  ></span>
                                  <span class="path2"></span>
                                </span>
                              </v-btn>
                            </template>
                            <span>Terminate</span>
                          </v-tooltip>

                          <v-menu style="margin-top: 12px" bottom right>
                            <template v-slot:activator="{ on }">
                              <v-btn height="32" width="32" v-on="on" icon>
                                <span
                                    style="font-size: 28px; margin-right: 2px"
                                    class="icon-more-21x21 letterSpacing0"
                                >
                                  <span class="path1 letterSpacing0"></span>
                                  <span class="path2 letterSpacing0"></span>
                                  <span class="path3 letterSpacing0"></span>
                                  <span class="path4 letterSpacing0"></span>
                                </span>
                              </v-btn>
                            </template>
                            <v-list dense>
                              <template v-for="listItem in items">
                                <v-list-item
                                    v-if="showInstanceAction(listItem)"
                                    :key="listItem.title"
                                    @click="
                                    handleAction(
                                      item.id,
                                      listItem.action,
                                      item.name
                                    )
                                  "
                                >
                                  <v-list-item-action class="mr-3">
                                    <v-icon small>{{ listItem.icon }}</v-icon>
                                  </v-list-item-action>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      {{ listItem.title }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-list>
                          </v-menu>
                        </div>
                      </v-col>
                    </v-row>
                    <td
                        v-for="header in headersCounter - 1"
                        :key="header"
                        style="border: none"
                    ></td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  <v-row class="mx-0 fullSize" justify="center">
                    <v-col align-self="center">
                      <v-row justify="center">
                        <p style="color: #d4d4d4; font-size: 16px">
                          Click
                          <v-icon color="primary" class="pb-1">add
                          </v-icon
                          >&nbsp;to run an application
                        </p>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-data-table>
              <div class="text-center custom-table-footer">
                <v-row justify="space-between" justify-sm="end" class="mx-0">
                  <div class="ml-2 pagination-item-1">
                    <div v-if="$vuetify.breakpoint.smAndUp" class="mr-6">
                      Rows per page:
                    </div>
                    <div
                        :class="{ 'mr-1': $vuetify.breakpoint.smAndUp }"
                        class="footer-items-wrapper"
                    >
                      <v-select
                          dense
                          class="footer-items-per-page mt-0"
                          hide-details
                          :menu-props="{ top: true, offsetY: true }"
                          :items="[10, 25, 50, 100]"
                          v-model="itemsPerPage"
                      >
                        <template v-slot:item="{ item }">
                          <div class="mb-0 char-lim-tabs page-rows-selection">
                            <div v-if="item === -1">All</div>
                            <div v-else>{{ item }}</div>
                          </div>
                        </template>
                        <template v-slot:selection="{ item }">
                          <div class="page-rows-selection">
                            <div v-if="item === -1">All</div>
                            <div v-else>
                              {{ item }}
                            </div>
                          </div>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <v-pagination
                      v-model="page"
                      :length="pageCount"
                      :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 7"
                      circle
                      class="pagination"
                  ></v-pagination>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-dialog
            transition="scroll-x-transition"
            overlay-color="grey darken-2"
            v-model="debugDialog"
            max-width="700"
            content-class="overflowY-hidden"
            persistent
        >
          <v-card color="accent" style="min-height: 200px; max-width: 700px">
            <v-card-title
                style="
                background-color: #47bd96;
                color: white;
                letter-spacing: 0.03rem;
                height: 40px;
              "
                :style="
                $vuetify.breakpoint.xsOnly
                  ? 'text-align: center !important;'
                  : ''
              "
            >Debug View
            </v-card-title
            >
            <div style="max-height: 600px; overflow-y: auto">
              <v-btn
                  @click="handleAction(agentDebugging, ACTIONS.DEBUG)"
                  class="primary more-btn mt-1 mr-1"
                  style="right: 10px; top: 45px"
                  icon
                  text
                  dark
                  width="28"
                  height="28"
              >
                <v-icon small style="font-size: 16px">fas fa-redo-alt</v-icon>
              </v-btn>
              <div class="pl-5 pt-5" style="min-height: 200px">
                <v-row
                    v-if="loadingDebug"
                    class="mx-0"
                    align="center"
                    justify="center"
                    style="min-height: 200px"
                >
                  <v-progress-circular
                      :size="20"
                      width="2"
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                </v-row>
                <v-row
                    v-else-if="debugInfo != null"
                    class="mx-0"
                    align="center"
                    style="min-height: 200px"
                >
                  <pre style="font-size: 14px; width: 700px">{{
                      debugInfo
                    }}</pre>
                </v-row>
                <div v-else>
                  <v-img
                      class="mt-5 mx-auto text-center"
                      max-height="170"
                      max-width="170"
                      src="/img/dynamic-src-images/errors/oops-error.svg"
                  ></v-img>
                  <p
                      class="mb-0 mt-3 text-center"
                      style="font-size: 16px; overflow-x: auto"
                  >
                    Something went wrong!
                  </p>
                </div>
              </div>
            </div>
            <v-card-actions>
              <v-btn text color="primary" @click="debugDialog = !debugDialog"
              >close
              </v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
            transition="scroll-x-transition"
            overlay-color="grey darken-2"
            v-model="dialog"
            max-width="480"
            content-class="overflowX-hidden"
            persistent
        >
          <v-card color="accent">
            <v-card-title
                style="background-color: #47bd96; color: white"
                :style="
                $vuetify.breakpoint.xsOnly
                  ? 'text-align: center !important;'
                  : ''
              "
            >
              Run Application
            </v-card-title>
            <v-container class="pb-0" wrap raw>
              <v-layout row wrap>
                <v-flex sm12>
                  <v-row justify="center">
                    <v-col cols="11">
                      <h3
                          style="text-align: center"
                          class="subtitle-1"
                          :class="{
                          'primary--text': !availableApplications.length,
                        }"
                      >
                        {{
                          availableApplications.length
                              ? "Select which applications you want to create"
                              : "All applications are created"
                        }}
                      </h3>
                    </v-col>
                  </v-row>
                </v-flex>

                <v-container class="py-0" fluid>
                  <v-row align="center" justify="center">
                    <v-col class="py-0" cols="12" md="9" sm="9">
                      <v-select
                          v-if="!loadingAvailableApps"
                          :disabled="!availableApplications.length"
                          dense
                          outlined
                          v-model="selectedApplications"
                          :items="availableApplications"
                          :menu-props="{ offsetY: true, maxHeight: '250' }"
                          item-text="name"
                          item-value="id"
                          :label="`Select apps ${
                          !availableApplications.length ? '(0)' : ''
                        }`"
                          multiple
                      >
                        <template v-slot:prepend-item>
                          <v-list-item
                              style="
                              max-height: 40px;
                              border-bottom: 1px solid #7f7f7f;
                            "
                              ripple
                              @click="selectAllInstances"
                          >
                            <v-list-item-content>
                              <v-list-item-title
                                  :class="
                                  selectedApplications.length ===
                                  availableApplications.length
                                    ? 'primary--text'
                                    : $vuetify.theme.dark
                                    ? 'white--text'
                                    : 'black--text'
                                "
                                  style="
                                  font-size: 16px !important;
                                  font-weight: 400;
                                "
                              >Select All
                              </v-list-item-title
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template v-slot:item="{ item }">
                          <div class="mb-0 char-lim-tabs">
                            <div>{{ item.name }}</div>
                          </div>
                        </template>
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index === 0">
                            <span>{{ item.name }}</span>
                          </v-chip>
                          <span v-if="index === 1">
                            (+{{ selectedApplications.length - 1 }}
                            others)
                          </span>
                        </template>
                      </v-select>
                      <v-progress-circular
                          v-else
                          :size="20"
                          width="2"
                          color="primary"
                          indeterminate
                      ></v-progress-circular>
                    </v-col>
                  </v-row>
                  <v-row justify="center" style="height: 40px !important">
                    <v-col class="pa-0" cols="12" md="9" sm="9">
                      <v-checkbox
                          v-model="autoRunApps"
                          dense
                          x-small
                          label="Autostart selected applications"
                          class="smaller-checkbox mt-0 ml-2"
                          on-icon="fas fa-check-square"
                          off-icon="far fa-check-square"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <v-row
                      v-if="
                      noAppsSelected &&
                      selectedApplications.length === 0 &&
                      availableApplications.length
                    "
                      justify="center"
                  >
                    <v-col xs="7" class="py-0">
                      <p style="color: #ff3232; text-align: center">
                        Please select at least one application.
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-layout>
            </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="dialog = false">Cancel</v-btn>
              <v-btn text @click="createApplication" color="primary"
              >Create
              </v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-fab-transition>
          <v-btn
              v-if="
              !loading &&
              getApplicationInstances.length &&
              !appInstancesError.error &&
              (isAdmin === true)
            "
              fab
              bottom
              right
              :style="{ bottom: '70px' }"
              :color="$vuetify.theme.dark ? '#685AA1' : 'primary'"
              dark
              fixed
              @click="showRunApplicationDialog"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {ApplicationInstanceService} from "@/services/ApiService";
import {mapGetters, mapActions} from "vuex";
import {
  LoadingPage,
  DefaultPage,
} from "../components/Default-Page-Components";
import {USER_ROLES} from "@/utilities/enums";

var fetchApplicationsInterval;

export default {
  components: {LoadingPage, DefaultPage},
  data() {
    return {
      page: 1,
      pageCount: 0,
      itemsPerPage: 25,
      agentDebugging: null,
      loadingDebug: true,
      debugInfo: [],
      debugDialog: false,
      loadingApps: false,
      loadingAvailableApps: false,
      actionsMenuCurrentID: null,
      PING_STATUS: {
        DEFAULT: 0,
        ACTIVE: 1,
        DONE: 2,
        REJECTED: 3,
      },
      pinging: 0,
      actionsPanel: false,
      USER_ROLES: USER_ROLES,
      autoRunApps: true,
      COLUMN_SORTS: {
        NUMBERS: {DESC: 0, ASC: 1},
        STRINGS: {DESC: 2, ASC: 3},
        DATES: {DESC: 4, ASC: 5},
      },
      selectedHeader: "",
      currentSortingAlgo: (items) => items,
      expanded: [],
      noAppsSelected: false,
      ACTIONS: {
        PING: "CMD_CMN_PING",
        START: "CMD_CMN_START",
        SUSPEND: "CMD_CMN_SUSPEND",
        RESUME: "CMD_CMN_RESUME",
        TERMINATE: "CMD_CMN_TERMINATE",
        CFG: "CMD_CMN_CFG",
        DEBUG: "CMD_CMN_DEBUG",
        CONFIGURE: "1",
      },
      items: [
        {title: "terminate", icon: "close", action: "KILL"},
        {
          title: "ping",
          icon: "send",
          action: "CMD_CMN_PING",
        },

        {title: "reload", icon: "fa fa-sync-alt", action: "CMD_CMN_CFG"},
        {title: "configuration", icon: "fas fa-cogs", action: "configure"},
        {title: "debug", icon: "fas fa-bug", action: "CMD_CMN_DEBUG"},
      ],
      selectedApplications: [],
      availableApplications: [],
      application: {
        description: "",
        id: null,
        login: null,
        name: "",
        password: "",
        port: "",
        server: "",
        version: "",
      },
      dialog: false,
      loading: true,
      loadingIds: [],
      playButtonLoading: false,
      terminateButtonLoading: false,
      error: null,
      headers: [
        {
          text: "Name",
          value: "name",
          align: "left",
          sortable: false,
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Status",
          value: "appStatus",
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Connectivity",
          value: "serverStatus",
          type: "String",
          currentSortAlg: null,
        },
        {
          text: "Version",
          value: "version",
          type: "String",
          currentSortAlg: null,
        },
        {text: "Actions", value: "action", sortable: false},
      ],
      appInstancesError: {},
      pageKey: 0,
    };
  },
  created() {
    if (window.innerWidth > 320 && !this.isNotDesktop) {
      document.getElementById("htmlId").style.overflowY = "hidden";
    }

    if (this.pageReloaded) {
      this.fetchAvailableApplications();
      this.executeShortCuts();
    } else this.loadingInstances();

    this.appInstancesError = this.getApplicationInstancesErrorState();

    fetchApplicationsInterval = setInterval(() => {
      this.appInstancesError = this.getApplicationInstancesErrorState();

      if (!this.loadingApps) {
        this.loadingApps = true;
        return this.$store
            .dispatch("instances/fetchApplicationInstances")
            .then(() => {
              this.loadingApps = false;
            });
      }
    }, 2000);
  },
  computed: {
    addButtonOverLaps() {
      return (
          this.$vuetify.breakpoint.width > 670 &&
          this.$vuetify.breakpoint.width < 900
      );
    },
    pageText() {
      if (this.availableApplications.length)
        return "It seems that you don't have any application instances running. Click Get Started below to add an application";
      else
        return "It seems that you don't have any configurations|Click Get Started below to go to Configurations page";
    },
    headersCounter() {
      switch (true) {
        case this.$vuetify.breakpoint.width < 411:
          return 1;
        case this.$vuetify.breakpoint.width < 500:
          return 2;
        case this.$vuetify.breakpoint.width < 703:
          return 3;
        default:
          return this.headers.length;
      }
    },
    getApplicationInstancesAndIndexes() {
      return this.getApplicationInstances.map((el, index) => {
        el.index = index;
        el.more = false;
        return el;
      });
    },
    ...mapGetters("instances", [
      "getApplicationInstances",
      "getApplicationInstancesUnfiltered",
    ]),
    ...mapGetters(["isAdmin"]),
  },
  props: {
    pageReloaded: {
      type: Boolean,
      default: true,
    },
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    windowSizeY: {
      type: Number,
      default: 1200,
    },
  },
  methods: {
    setDebugView(data) {
      this.debugInfo = JSON.stringify(data, null, 2);
    },
    showInstanceAction(item) {
      if (item.title === "debug") {
        return !!this.isAdmin;
      } else return true;
    },
    terminateApplication(itemId) {
      this.terminateButtonLoading = true;
      this.playButtonLoading = false;
      this.loadingIds.push(itemId);
      this.handleAction(itemId, this.ACTIONS.TERMINATE);
    },
    executeShortCuts() {
      let i = 0;
      var shortcutsTimeout = setInterval(() => {
        i++;
        if (i > 60) clearInterval(shortcutsTimeout);
        if (
            !this.loading &&
            this.appInstancesError.hasOwnProperty("error") &&
            !this.appInstancesError.error
        ) {
          if (this.$route.query && this.$route.query.add) {
            if (!this.dialog) this.dialog = true;
          }
          clearInterval(shortcutsTimeout);
        }
      }, 100);
    },
    buttonClicked() {
      if (this.appInstancesError.error) this.reloadThisPage();
      else if (this.availableApplications.length)
        this.showRunApplicationDialog();
      else this.$router.push("/configurations");
    },
    selectAllInstances() {
      if (this.selectedApplications.length === this.availableApplications.length)
        this.selectedApplications = [];
      else
        this.selectedApplications = this.availableApplications.map(
            (el) => el.id
        );
    },
    getCellClass(item, header) {
      switch (header) {
        case "serverStatus":
          switch (item) {
            case "CONNECTED":
              return "text-xs-left success--text";
            default:
              return "text-xs-left error--text";
          }
        case "appStatus":
          if (["RUN", "STARTED"].includes(item)) {
            return "text-xs-left status open appStatusWidth";
          } else if (item === "INITIALIZED") {
            return "text-xs-left status in-progress appStatusWidth";
          } else {
            return "text-xs-left status dead appStatusWidth";
          }
        case "name":
          if (
              this.$vuetify.breakpoint.width < 480 &&
              this.$vuetify.breakpoint.width > 410
          )
            return "char-lim ml-0 pr-5";
          return "char-lim ml-0";
        default:
          return "uselessClass";
      }
    },
    getSortingIcon(algo) {
      switch (algo) {
        case this.COLUMN_SORTS.NUMBERS.ASC:
        case this.COLUMN_SORTS.STRINGS.ASC:
        case this.COLUMN_SORTS.DATES.ASC:
          return "fas fa-arrow-down";
        default:
          return "fas fa-arrow-up";
      }
    },
    clearAllHeadersSorting(header) {
      this.headers.map((el) => {
        if (el.text !== header.text && el.currentSortAlg != null) {
          el.currentSortAlg = null;
          return el;
        } else {
          return el;
        }
      });
    },
    getNewSortingAlgo(header) {
      if (header.text !== this.selectedSort) {
        this.selectedSort = this.headers.find(
            (el) => el.value === header.value
        ).text;
      }
      switch (header.type) {
        case "Number":
          if (
              header.currentSortAlg == null ||
              header.currentSortAlg === this.COLUMN_SORTS.NUMBERS.DESC
          ) {
            header.currentSortAlg = this.COLUMN_SORTS.NUMBERS.ASC;
            this.clearAllHeadersSorting(header);
            return this.numSortAsc;
          } else {
            header.currentSortAlg = this.COLUMN_SORTS.NUMBERS.DESC;
            this.clearAllHeadersSorting(header);
            return this.numSortDesc;
          }
        case "String":
          if (
              header.currentSortAlg == null ||
              header.currentSortAlg === this.COLUMN_SORTS.STRINGS.DESC
          ) {
            header.currentSortAlg = this.COLUMN_SORTS.STRINGS.ASC;
            this.clearAllHeadersSorting(header);
            return this.stringSortAsc;
          } else {
            header.currentSortAlg = this.COLUMN_SORTS.STRINGS.DESC;
            this.clearAllHeadersSorting(header);
            return this.stringSortDesc;
          }
      }
    },
    numSortAsc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.NUMBERS.ASC);
    },
    numSortDesc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.NUMBERS.DESC);
    },
    stringSortAsc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.STRINGS.ASC);
    },
    stringSortDesc(items) {
      return this.secondarySort(items, this.COLUMN_SORTS.STRINGS.DESC);
    },
    secondarySort(items, typeAndOrder) {
      switch (typeAndOrder) {
        case this.COLUMN_SORTS.NUMBERS.ASC:
          return items.sort(
              (a, b) => a[this.selectedHeader] - b[this.selectedHeader]
          );
        case this.COLUMN_SORTS.NUMBERS.DESC:
          return items.sort(
              (a, b) => b[this.selectedHeader] - a[this.selectedHeader]
          );
        case this.COLUMN_SORTS.STRINGS.ASC:
          return items.sort((a, b) =>
              a[this.selectedHeader] > b[this.selectedHeader]
                  ? 1
                  : b[this.selectedHeader] > a[this.selectedHeader]
                      ? -1
                      : 0
          );
        case this.COLUMN_SORTS.STRINGS.DESC:
          return items.sort((a, b) =>
              b[this.selectedHeader] > a[this.selectedHeader]
                  ? 1
                  : a[this.selectedHeader] > b[this.selectedHeader]
                      ? -1
                      : 0
          );
        default:
          return;
      }
    },
    expandRow(item) {
      if (this.expanded.length) {
        if (this.expanded[0].id === item.id) {
          this.expanded.pop();
        } else {
          this.expanded.pop();
          this.expanded.push(item);
        }
      } else {
        this.expanded.push(item);
      }
    },
    loadingInstances() {
      this.loading = true;
      this.$store
          .dispatch("instances/fetchApplicationInstances")
          .then(() => {
            this.loading = false;
            this.fetchAvailableApplications();
            this.executeShortCuts();
          })
          .catch((err) => {
            console.error(err);
            this.appInstancesError = this.getApplicationInstancesErrorState();
            this.loading = false;
            this.executeShortCuts();
          });
    },
    reloadThisPage() {
      this.loadingInstances();
      this.pageKey = this.pageKey > 8 ? 1 : this.pageKey + 1;
    },
    checkStatus: () => {
      return {
        isRunAllowed(status) {
          return ["SUSPENDED", "INITIALIZED"].includes(status);
        },
        isTerminateAllowed(status) {
          return ["SUSPENDED", "RUN", "STARTED", "TERMINATED"].includes(status);
        },
      };
    },
    showRunApplicationDialog() {
      if (this.isAdmin === true) {
        this.autoRunApps = true;
        this.noAppsSelected = false;
        this.dialog = !this.dialog;
        this.selectedApplications = [];
        this.fetchAvailableApplications();
      }
    },
    fetchAvailableApplications() {
      this.loadingAvailableApps = true;
      ApplicationInstanceService.query({
        params: {fetchAvailable: true},
      })
          .then((response) => {
            this.loadingAvailableApps = false;
            this.availableApplications = response.data.filter(
                (el) => el.appStatus === "EXITED"
            );
            this.loading = false;
            this.executeShortCuts();
          })
          .catch((error) => {
            this.loadingAvailableApps = false;
            this.loading = false;
            console.error(error);
          });
    },
    handleAction(id, action, name) {
      if (action === this.ACTIONS.DEBUG) {
        this.debugInfo = null;
        this.loadingDebug = true;
        this.debugDialog = true;
        this.agentDebugging = id;
      }
      if (action !== this.ACTIONS.PING) {
        this.actionsPanel = false;
        this.actionsMenuCurrentID = null;
        this.$forceUpdate();
      } else {
        this.pinging = this.PING_STATUS.ACTIVE;
      }
      switch (action) {
        case "KILL":
          this.deleteApplicationInstanceById(id, name);
          break;
        case "configure":
          this.$router.push({path: "/configurations", query: {edit: id}});
          break;
        case this.ACTIONS.DEBUG:
        case this.ACTIONS.RESUME:
        case this.ACTIONS.START:
        case this.ACTIONS.SUSPEND:
        case this.ACTIONS.TERMINATE:
        case this.ACTIONS.CFG:
        case this.ACTIONS.PING:
          ApplicationInstanceService.update(id, {command: action})
              .then((response) => {
                if (action === this.ACTIONS.DEBUG) {
                  this.setDebugView(response.data);
                  this.loadingDebug = false;
                }
                if (action === this.ACTIONS.PING) {
                  this.pinging = this.PING_STATUS.DONE;
                  this.$notifier.success(`Pinging ${name} successful`);
                }
                if (action === this.ACTIONS.TERMINATE) {
                  this.terminateButtonLoading = false;
                }
                this.playButtonLoading = false;
                this.fetchApplicationInstances();
              })
              .catch((error) => {
                if (action === this.ACTIONS.DEBUG) {
                  this.loadingDebug = false;
                }
                if (action === this.ACTIONS.PING) {
                  this.pinging = this.PING_STATUS.REJECTED;
                }
                this.terminateButtonLoading = false;
                this.playButtonLoading = false;

                if (error.response && error.response.data.error === "Not Found") {
                  this.$notifier.error(
                      "Could not find this instance. Please refresh the page"
                  );
                } else if (action === this.ACTIONS.PING) {
                  this.$notifier.error(`Pinging ${name} unsuccessful`);
                } else {
                  this.$notifier.error(error.response.data.message);
                }
              });
          break;

        default:
          console.error(`Unknown action ${action}`);
      }
    },
    deleteApplicationInstanceById(id, name) {
      ApplicationInstanceService.delete(id)
          .then(() => {
            this.$notifier.info(`Application Instance ${name} was deleted!`);
            this.fetchApplicationInstances();
          })
          .catch((error) =>
              this.$notifier.error(error.response.data.message, {
                error: error,
              })
          );
    },

    async createApplication() {
      if (this.selectedApplications.length > 0) {
        this.noAppsSelected = false;
        await this.selectedApplications.forEach((applicationId) => {
          this.createApplicationInstance({
            autoRun: this.autoRunApps,
            id: applicationId,
          }).catch((error) => {
            this.$notifier.error(error.response.data.message, {
              error: error,
            });
          });
        });

        this.dialog = false;
      } else {
        this.noAppsSelected = true;
      }
    },
    ...mapActions("instances", [
      "fetchApplicationInstances",
      "createApplicationInstance",
    ]),
    ...mapGetters("instances", ["getApplicationInstancesErrorState"]),
  },
  watch: {
    getApplicationInstances(v) {
      if (!v.length) {
        this.availableApplications = JSON.parse(
            JSON.stringify(
                this.getApplicationInstancesUnfiltered.filter(
                    (el) => el.appStatus === "EXITED"
                )
            )
        );
      }
      this.loadingIds = this.loadingIds.filter((loadId) => {
        return !!v.some((instance) => instance.id === loadId);
      });
    },
  },
  beforeDestroy() {
    clearInterval(fetchApplicationsInterval);
  },
};
</script>
<style scoped src="../css/utilities/scoped/applications.css"></style>
